import { TextField, MenuItem, Typography } from '@mui/material';

export const Screen4Form = ({ formData, onInputChange, industries }) => {
  // Define the options for each dropdown
  const customerOptions = ['ACME Industrial'];
  const execNameOptions = ['Penelope Adams', 'Niles Bronson', 'Ian Farnsworth', 'Chase Harding', 'Susan Wang'];
  const execTitleOptions = [
    'Chief Executive Officer (CEO)',
    'Chief Information Officer (CIO)',
    'Chief Data Protection Officer (CDPO)',
    'Chief Information security Officer (CISO)',
    'Chief Technical Officer (CTO)',
    'VP Engineering',
  ];
  const competitorOptions = ['Google', 'Microsoft', 'META', 'NVIDIA'];

  return (
    <div className="p-6">
      <div className="mb-6">
        <Typography variant="h5" mb={1}>
          Customer's Name <span className="text-red-500">*</span>
        </Typography>
        <TextField
          select
          fullWidth
          variant="outlined"
          value={formData.customerName}
          onChange={e => onInputChange('customerName', e.target.value)}
          className="mb-4"
          size="small"
          required
        >
          <MenuItem value="">Select Customer</MenuItem>
          {customerOptions.map(customer => (
            <MenuItem key={customer} value={customer}>
              {customer}
            </MenuItem>
          ))}
        </TextField>
      </div>

      <div className="mb-6">
        <Typography variant="h5" mb={1}>
          Executive's Name <span className="text-red-500">*</span>
        </Typography>
        <TextField
          select
          fullWidth
          variant="outlined"
          value={formData.executiveName}
          onChange={e => onInputChange('executiveName', e.target.value)}
          className="mb-4"
          size="small"
          required
        >
          <MenuItem value="">Select Executive</MenuItem>
          {execNameOptions.map(exec => (
            <MenuItem key={exec} value={exec}>
              {exec}
            </MenuItem>
          ))}
        </TextField>
      </div>

      <div className="mb-6">
        <Typography variant="h5" mb={1}>
          Executive's Title <span className="text-red-500">*</span>
        </Typography>
        <TextField
          select
          fullWidth
          variant="outlined"
          value={formData.executiveTitle}
          onChange={e => onInputChange('executiveTitle', e.target.value)}
          className="mb-4"
          size="small"
          required
        >
          <MenuItem value="">Select Title</MenuItem>
          {execTitleOptions.map(title => (
            <MenuItem key={title} value={title}>
              {title}
            </MenuItem>
          ))}
        </TextField>
      </div>

      <div className="mb-6">
        <Typography variant="h5" mb={1}>
          Industry <span className="text-red-500">*</span>
        </Typography>
        <TextField
          select
          fullWidth
          variant="outlined"
          size="small"
          value={formData.industry}
          onChange={e => onInputChange('industry', e.target.value)}
          required
        >
          <MenuItem value="">Select Industry</MenuItem>
          {industries.map(industry => (
            <MenuItem key={industry} value={industry}>
              {industry}
            </MenuItem>
          ))}
        </TextField>
      </div>

      <div className="mb-6">
        <Typography variant="h5" mb={1}>
          Primary Competitor <span className="text-red-500">*</span>
        </Typography>
        <TextField
          select
          fullWidth
          variant="outlined"
          value={formData.primaryCompetitor}
          onChange={e => onInputChange('primaryCompetitor', e.target.value)}
          className="mb-4"
          size="small"
          required
        >
          <MenuItem value="">Select Competitor</MenuItem>
          {competitorOptions.map(competitor => (
            <MenuItem key={competitor} value={competitor}>
              {competitor}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );
};
